import React, {
  ReactNode,
} from 'react';
import clsx from 'clsx';
import Skeleton from 'core/components/Skeleton';

type Parts = 'root' | 'title' | 'skeleton';

export type RowProps = {
  title: ReactNode | string;
  className?: string;
  children: ReactNode | string;
  delimiter?: string | null;
  classes?: Partial<Record<Parts, string>>;
  isLoading?: boolean;
};

export default function Row({
  title,
  className,
  classes,
  delimiter = ':',
  children,
  isLoading,
}: RowProps) {
  return (
    <div className={clsx(
      'populate-information-row flex justify-between p-2 text-xs border-b border-b-gray-300 items-center last:border-b-0',
      classes?.root,
      className,
    )}
    >
      <span className={clsx('text-gray-500 font-semibold mr-0.5', classes?.title)}>
        {title}
        {delimiter}
      </span>
      {isLoading ? (
        <Skeleton className={clsx('!h-4', classes?.skeleton)} />
      ) : (
        children
      )}
    </div>
  );
}
